import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/goalsSagas";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";

const ViewFilter = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.goals.view);
  const selectedView = useSelector((state) => state.goals.selectedView);

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedView}
      includeFilter={false}
      onSelectChange={(data) => {
        if (data.id === selectedView.id) return;
        dispatch(actionCreators.updateView(data));
      }}
    />
  );
};

export default ViewFilter;
